import React from "react";
import { app_path } from "config";
import styled from "styled-components";
import { Banner, Icon, Typography } from "@plum-xoxo/admin-dsm";

const CustomImgBackground = styled.div`
  background: ${(props) => props.theme.palette.primary.c00};
  border-radius: 8px;
  padding: 14px;
`;
class PaymentSummary extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { selectedPayment, currencyCode = "INR" } = this.props;
    const redirectPage = this.props.rechargeState?.redirectPage;
    redirectPage &&
      selectedPayment === "online" &&
      this.props.rechargeState?.phnNum &&
      this.props.handleOnlinePayment(currencyCode || "INR");
  }

  renderCurrencyInFormat = (amount) => {
    return Number(amount)
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, "$&,");
  };

  render() {
    const {
      formatedNetAmount,
      paymentGatewayFeePercent,
      formatedPaymentGatewayAmount,
      currencyCode = "INR",
      formatedtotal,
      selectedPayment,
      showCheckoutLoader,
      payPalButtonloader,
      markupPercent,
      formatedMarkupAmount,
      discountPercent,
      discountAmount,
      kybStatus: { kyb_status = 0, threshold = 0 } = {},
      is_proforma_invoice = 0,
      formatedGstAmount = "",
      gstPercent = 0,
      isCompanyAddressPresent = false,
      showAddCompanyAddressLoader = false,
      formatDiscountAmount,
      companyAddress,
      selectedCountry,
      selectedState,
      selectedCity,
      nonVerifiedPhoneNumber,
    } = this.props;
    const redirectPage = this.props.rechargeState?.redirectPage;
    const recipientCount = redirectPage?.startsWith(`/${app_path}/xoxo-code`)
      ? JSON.parse(sessionStorage.getItem("xoxoCodeState"))
          ?.nonSchedule_count || 0
      : JSON.parse(sessionStorage.getItem("xoxoPointsState"))?.recipientData
          ?.length || 0;
    return (
      <div className="paymentSummary">
        <div>
          <div className="alignInSameRow">
            <CustomImgBackground>
              <Icon
                color="primary"
                iconName="PlumPaymentSummary"
                onClick={() => {}}
                shade="c02"
                size="24"
              />
            </CustomImgBackground>
            <Typography.H2 color="dark" shade="c300" className="ml-16">
              Payment Summary
            </Typography.H2>
          </div>
        </div>
        <div className="mt-40">
          {redirectPage ? (
            <div className="alignInSameRow justify-content-between mb-20">
              <div className="fw-400 fs-14 inkNormal">No. Of Recipient</div>
              <div className="fw-500">{recipientCount}</div>
            </div>
          ) : null}
          <div className="alignInSameRow justify-content-between">
            <Typography color="dark" shade="c300" className="">
              {redirectPage ? "Reward Value" : "Net Amount"}
            </Typography>
            <Typography color="dark" shade="c300">
              {this.renderCurrencyInFormat(
                Number.parseFloat(
                  formatedNetAmount.split(" ").length > 1
                    ? formatedNetAmount.split(" ")[1]
                    : formatedNetAmount
                )
              )}
            </Typography>
          </div>

          {markupPercent != 0 ? (
            <div className="alignInSameRow justify-content-between mt-3">
              <div className="alignInSameRow justify-content-between">
                <Typography component="span" color="dark" shade="c300">
                  Markup Charges
                </Typography>{" "}
                <Typography
                  component="span"
                  color="dark"
                  shade="c300"
                  className="m-0"
                >
                  ({markupPercent}%)
                </Typography>
              </div>
              <div className="fw-500">
                {this.renderCurrencyInFormat(
                  Number.parseFloat(
                    formatedMarkupAmount.split(" ").length > 1
                      ? formatedMarkupAmount.split(" ")[1]
                      : formatedMarkupAmount
                  )
                )}
              </div>
            </div>
          ) : null}

          {gstPercent != 0 ? (
            <div className="alignInSameRow justify-content-between mt-3">
              <div className="alignInSameRow justify-content-between">
                <Typography component="span" color="dark" shade="c300">
                  Tax applicable
                </Typography>{" "}
                <Typography
                  component="span"
                  color="dark"
                  shade="c300"
                  className="m-0"
                >
                  ({gstPercent}% on Markup)
                </Typography>
              </div>
              <div className="fw-500">
                {this.renderCurrencyInFormat(
                  Number.parseFloat(
                    formatedGstAmount.split(" ").length > 1
                      ? formatedGstAmount.split(" ")[1]
                      : formatedGstAmount
                  )
                )}
              </div>
            </div>
          ) : null}

          {paymentGatewayFeePercent != 0 ? (
            <div className="alignInSameRow justify-content-between mt-3">
              <div className="alignInSameRow justify-content-between">
                <Typography component="span" color="dark" shade="c300">
                  Transaction charges
                </Typography>{" "}
                <Typography
                  component="span"
                  color="dark"
                  shade="c300"
                  className="m-0"
                >
                  ({paymentGatewayFeePercent}% processing fee)
                </Typography>
              </div>
              <div className="fw-500">
                {this.renderCurrencyInFormat(
                  Number.parseFloat(
                    formatedPaymentGatewayAmount.split(" ").length > 1
                      ? formatedPaymentGatewayAmount.split(" ")[1]
                      : formatedPaymentGatewayAmount
                  )
                )}
              </div>
            </div>
          ) : null}

          {discountPercent != 0 ? (
            <div className="alignInSameRow justify-content-between mt-3 mb-20">
              <div className="alignInSameRow justify-content-between">
                <Typography component="span" color="dark" shade="c300">
                  Discount
                </Typography>{" "}
                <Typography
                  component="span"
                  color="dark"
                  shade="c300"
                  className="m-0"
                >
                  ({discountPercent}%)
                </Typography>
              </div>
              <div className="fw-500">
                {this.renderCurrencyInFormat(
                  Number.parseFloat(
                    formatDiscountAmount.split(" ").length > 1
                      ? formatDiscountAmount.split(" ")[1]
                      : formatDiscountAmount
                  )
                )}
              </div>
            </div>
          ) : null}

          <hr className="mt-4 mb-4" />
          <div className="totalPayable mt-20">
            <div className="d-flex justify-content-between align-items-center">
              <Typography component="span" color="dark" shade="c300">
                Total payable
              </Typography>
              <Typography.H1 component="span" color="dark" shade="c300">
                {currencyCode}{" "}
                {formatedtotal.split(" ").length > 1
                  ? this.renderCurrencyInFormat(formatedtotal.split(" ")[1])
                  : this.renderCurrencyInFormat(formatedtotal)}
              </Typography.H1>
            </div>
          </div>
          {kyb_status === 0 && (
            <Banner
              className="mt-36"
              description={
                <Typography color="dark" shade="c300" className="mb-0">
                  You can send reward upto{" "}
                  <Typography.ButtonText
                    component="span"
                    color="dark"
                    shade="c300"
                  >
                    threshold ({currencyCode} {threshold})
                  </Typography.ButtonText>
                  . For above, please submit your account verification details.
                </Typography>
              }
            />
          )}

          {/* <hr style={{ marginTop: "20px", marginBottom: "20px" }} /> */
          /* {kyb_status !== 2 ? (
            <div
              style={{
                background: "#F5F7F9",
                padding: "1.5rem",
                margin: "2rem 0",
                display: "flex",
              }}
            >
              <img
                style={{
                  marginRight: "10px",
                  position: "relative",
                  top: "5px",
                }}
                src="/admin/img/svg-icons/Vector.png"
                alt=""
                width="20px"
                height="20px"
              />
              <p style={{ color: "#252A31" }}>
                You can send reward or recharge upto threshold (
                {this.props.accountReducer?.userBalance?.currencySymbol}{" "}
                {threshold}). For above, please{" "}
                <a
                  onClick={() =>
                    this.props.history.push(
                      `/${app_path}/accounts/platform-preferences/`
                    )
                  }
                >
                  submit your account verification details.
                </a>
              </p>
            </div>
          ) : null}
                */}
          {/* {!isCompanyAddressPresent ? (
            <>
              <Button
                onClick={() => this.props.submitAddressDetails()}
                color="primary rounded w-100"
                disabled={
                  showAddCompanyAddressLoader ||
                  !companyAddress.company_address1 ||
                  !companyAddress.zip_code ||
                  !companyAddress.taxId ||
                  !selectedCountry.name ||
                  !selectedState.name ||
                  !selectedCity.name ||
                  (this.props.rechargeState?.phnNum
                    ? false
                    : !nonVerifiedPhoneNumber)
                }
              >
                {showAddCompanyAddressLoader ? (
                  <ImageLoader />
                ) : redirectPage ? (
                  "Add Funds & Send Reward"
                ) : (
                  "Save & Proceed"
                )}
              </Button>
              <div className="text-color-ink-light  fs-12 mt-2 fw-400">
                You can view & edit account verification details under platform
                preferences settings.
              </div>
            </>
          ) : selectedPayment === "online" ? (
            <>
              <Button
                onClick={() =>
                  !showCheckoutLoader
                    ? this.props.handleOnlinePayment(currencyCode)
                    : null
                }
                color="primary rounded w-100"
              >
                {showCheckoutLoader ? <ImageLoader /> : "Proceed to Pay Online"}
              </Button>
            </>
          ) : selectedPayment === "wireTransfer" ? (
            <>
              <Button
                onClick={() => this.props.proformaInvoice()}
                color="primary rounded w-100"
              >
                {showCheckoutLoader ? (
                  <ImageLoader />
                ) : currencyCode === "INR" ? (
                  "Proceed to Generate Invoice"
                ) : (
                  "Ok, Got It"
                )}
              </Button>
            </>
          ) : null}
          {selectedPayment === "paypal" ? (
            <>
              <hr className="mt-3 mb-3 pt-1 pb-1" />
              {!payPalButtonloader ? (
                <div
                  className="account-type"
                  style={{ textAlign: "center" }}
                  id="paypal-button-container"
                ></div>
              ) : (
                <Button color="primary rounded w-100">
                  <ImageLoader />
                </Button>
              )}
            </>
          ) : null} */}
        </div>
      </div>
    );
  }
}

export default PaymentSummary;
